import { useEffect, useState } from "react";
import { set, get, remove } from "@Core/LocalStorage";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../Redux/Action'


const SessionTimer = (props) => {
  const dispatch = useDispatch();
  const srmwuiCustomerObj = get('srmwuiCustomerObj') || {};
  const QueryperamData = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.QueryperamData : {};
  const userToken = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userToken : '';
  const validTo = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.validTo : '';
  const backToUrl = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.backToUrl : '';
  const userData = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userData :  {};
  const [remaining, setRemaining] = useState(0);
  const history = useHistory();

  // Step 1: calculate remaining time
  useEffect(() => {
    if (!validTo) return;

    const endTime = new Date(validTo).getTime();

    const updateRemaining = () => {
      const now = Date.now();
      const diff = Math.max(0, Math.floor((endTime - now) / 1000)); // in seconds
      setRemaining(diff);

      // auto logout when time expired
      if (diff <= 0) {
        userToken && handleLogout(userToken);
      }
    };

    updateRemaining(); // initial call
    const timer = setInterval(updateRemaining, 1000);

    return () => clearInterval(timer);
  }, [validTo, history]);


  const clearAllData = () => {
    remove('srmwuiCustomerObj');
    dispatch(actions.CommonActions.setLoggedIn(false))
    dispatch(actions.CommonActions.setUserToken(''))
    dispatch(actions.CommonActions.SetLoginFormData({ isLoginForm:false, error:{}}))
    dispatch(actions.CommonActions.SetHomeData({rewardsEnrollTermsConditions:false, sscTermsConditions:false,migrationTermsConditions:false,error:{}}))
  }

  const handleLogout = (tokenVal) => {
    dispatch(actions.CommonActions.setLoading(true));
    let data = {
      appTraceId: "string",
      userId: userData ? userData.userId : "",
      userToken: tokenVal,
    }
    dispatch(actions.CommonActions.Logout(tokenVal, data, (res) => {
      if (res && res.status == 200) {
        clearAllData();
        history.push(process.env.REACT_APP_SESSIONTIMEOUT_ROUTE);
        dispatch(actions.CommonActions.setLoading(false));
      }
      else {
        clearAllData();
        history.push(process.env.REACT_APP_SESSIONTIMEOUT_ROUTE);
        dispatch(actions.CommonActions.setLoading(false));
      }
    }))
  }

  // Step 2: format time
  const formatTime = (seconds) => {
    if (seconds >= 60) {
      const m = String(Math.floor(seconds / 60)).padStart(2, "0");
      const s = String(seconds % 60).padStart(2, "0");
      return `${m}:${s} mins`;
    } else {
      const s = String(seconds).padStart(2, "0");
      return `00:${s} secs`;
    }
  };

  return (
    <div
      style={{
        background: "#f8f9fa",
        padding: "10px 15px",
        borderRadius: "8px",
        fontWeight: "bold",
        textAlign: "center",
        width: "fit-content",
      }}
    >
      Session valid till: <span style={{ color: "#d9534f" }}>{formatTime(remaining)}</span>
    </div>
  );
};

export default SessionTimer;